import {Sidebar} from 'primereact/sidebar'
import {useEffect, useState} from 'react'
import {openPage} from '../../utils/NavigatorUtils'
import CustomForm from '../form-utils/CustomForm'
import {formLayout} from '../form/Constant'
import PageContentWrapper from '../layout/PageContentWrapper'
import {requestAccessEvent} from './RequestAccessService'
import {requestDataList} from './RequestConstants'

const RequestAccess = () => {
    const [visible, setVisible] = useState(false)

    // const onShow = () => {
    //     setVisible(true)
    // }
    const onHide = () => {
        openPage('/')
        setVisible(false)
    }

    useEffect(() => {
        requestAccessEvent.on('REQUEST-ACCESS-MODAL', () => setVisible(true))
    }, [])

    return (
        <Sidebar
            className="hide-sidebar-close p-sidebar-full "
            visible={visible}
            onHide={() => {}}
            fullScreen>
            <PageContentWrapper>
                <CustomForm
                    dataList={requestDataList}
                    layout={formLayout.group}
                    onSubmit={() => onHide()}
                />
            </PageContentWrapper>
        </Sidebar>
    )
}

export default RequestAccess
